'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'ARRANGE',
	name: 'Arrange',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*', '!ARRANGE_*'],
	category: 'Layout',
	props: [{
		name: 'bottom',
		inputType: 'checkbox',
		label: 'Bottom-aligned children',
		default: false
	}, {
		name: 'gutter',
		inputType: 'checkbox',
		label: 'Add gutter between cells',
		default: true
	}, {
		name: 'equal',
		inputType: 'checkbox',
		label: 'Set all children to equal width',
		default: false
	}, {
		name: 'middle',
		inputType: 'checkbox',
		label: 'Middle-aligned children'
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
};